import { JobType } from '../../../types/jobs';
import StyledModal from '../../shared/StyledModal';
import { JobTypeForm } from './JobTypeForm';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  jobTypeId?: string;
  jobType?: JobType;
  onSubmitFinished?: () => void;
};

export function JobTypeModal({ isOpen, onClose, jobTypeId, jobType, onSubmitFinished }: Readonly<Props>) {
  const editMode = jobTypeId !== undefined && jobType !== undefined;

  return (
    <StyledModal
      isOpen={isOpen}
      closeable
      onClose={onClose}
      size="auto"
      title={editMode ? 'Editar ' : 'Nuevo '}
      content={
        <JobTypeForm
          jobTypeId={jobTypeId}
          jobType={jobType}
          onCancel={onClose}
          onSubmitFinished={onSubmitFinished}
        />
      }
    />
  );
}
